import { render, staticRenderFns } from "./NewProductCompounds.vue?vue&type=template&id=5be32982&"
import script from "./NewProductCompounds.vue?vue&type=script&lang=js&"
export * from "./NewProductCompounds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports